import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import AxiosInstance from "../../../AxiosInstance";
import OtherPageHeader from "../../../components/OtherHeader";
import "./profilePage.css";
import { Accordion } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import {
  banksListController,
  countriesListController,
  statesListController,
} from "../../Helper/provider";
import { Select } from "antd";
import { Option } from "antd/es/mentions";
import { getBankAccountType } from "../../../utils";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function ProfilePage() {
  const {
    register,
    formState: { errors },
    control,
    setValue,
    getValues,
  } = useForm({ mode: "onChange" });
  const [countries, setCountries] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    getProfileDataNew();
    getSpinnerData();
  }, []);

  const countryChange = async (countryID) => {
    errors.countryId = false;
    setValue("countryId", parseInt(countryID));
    const list = await statesListController(countryID);
    setStateList(list);
  };
  const stateChange = (stateId) => {
    errors.stateId = false;
    setValue("stateId", parseInt(stateId));
  };
  const bankNameChange = (value) => {
    errors.bankId = false;
    setValue("bankId", parseInt(value));
  };
  const accountTypeChange = (type) => {
    errors.accountType = false;
    setValue("accountType", type);
  };
  const getSpinnerData = async () => {
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
    if (userData?.countryId) {
      const list = await statesListController(userData?.countryId);
      setStateList(list);
    }
  };
  const getProfileDataNew = async () => {
    let profileData = {};
    const result = await AxiosInstance()
      .get(`/user/me`)
      .catch((error) => {});
    profileData = result.data;
    setUserData(result.data);

    if (profileData) {
      console.log(profileData);
      setValue("name", profileData?.firstName + " " + profileData?.lastName);

      if (profileData.pan) {
        setValue("pan", profileData?.pan);
      }
      setValue("email", profileData?.email);
      setValue("phoneNumber", profileData?.phoneNumber);
      setValue("status", profileData?.status);

      if (profileData.address) setValue("address", profileData.address);

      if (profileData.city) setValue("city", profileData.city);
      if (profileData.countryId) {
        countryChange(profileData.countryId);
      }
      if (profileData.stateId) {
        console.log(profileData,"profileData");
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.UPICode) setValue("UPICode", profileData.UPICode);

      if (profileData.nominees && profileData.nominees[0]) {
        setValue("nomineeContact", profileData.nominees[0]?.contactNo);
        setValue("nomineeEmail", profileData.nominees[0]?.email);
        setValue("nomineeName", profileData.nominees[0]?.name);
        setValue("nomineeRelationship", profileData.nominees[0]?.relationship);
        if (profileData.nominees[0].dob)
          setValue(
            "nomineeDob",
            moment(profileData.nominees[0]?.dob).format("DD/MM/YYYY")
          );
      }
    }
  };
  return (
    <div className="bg-profile">
      <section className="tre_bg-gray position-relative">
        <OtherPageHeader
          classProps="bg-transparent"
          innerClassProps="bg-transparent"
        />
        <div className="container bg-partner">
          <button
            type="submit"
            title="back-button"
            className="back-button mt-3 "
            onClick={() => navigate(-1)}
          >
            {" "}
            <i className="fa fa-angle-left" /> Back
          </button>
          <b>
            {" "}
            <h1 className="mb-5 mt-1">Profile - {userData?.firstName}</h1>
          </b>
          <Accordion className="pb-5" defaultActiveKey="0" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  fill="currentColor"
                  className="bi bi-person-fill mx-3"
                  style={{ width: "30px", height: "30px" }}
                  viewBox="0 0 16 16"
                >
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                </svg>
                Personal Information
              </Accordion.Header>
              <Accordion.Body className="mx-0 mx-md-5">
                <label for="basic-url">Name</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    disabled={userData?.firstName || userData?.lastName}
                    id="name"
                    aria-describedby="basic-addon3"
                    {...register("name", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Email</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    disabled={userData?.email}
                    aria-describedby="basic-addon3"
                    {...register("email", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Mobile Number</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    disabled={userData?.phoneNumber}
                    id="phoneNumber"
                    aria-describedby="basic-addon3"
                    {...register("phoneNumber", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">PAN</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    disabled={userData?.pan}
                    class="form-control"
                    id="pan"
                    aria-describedby="basic-addon3"
                    {...register("pan", {
                      required: true,
                    })}
                  />
                  {userData?.isPanVerified && (
                    <div class="input-group-append">
                      <span class="input-group-text" id="basic-addon2">
                        <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                        <span className="mx-2"> Verified</span>
                      </span>
                    </div>
                  )}
                </div>
                <label for="basic-url">KYC</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="status"
                    aria-describedby="basic-addon3"
                    {...register("status", {
                      required: true,
                    })}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ width: "30px", height: "30px" }}
                  className="bi bi-geo-alt-fill mx-3"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>
                Address
              </Accordion.Header>
              <Accordion.Body className="mx-0 mx-md-5">
                <label for="basic-url">Address</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="address"
                    disabled={userData?.address}
                    aria-describedby="basic-addon3"
                    {...register("address", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">City</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    disabled={userData?.city}
                    class="form-control"
                    id="city"
                    aria-describedby="basic-addon3"
                    {...register("city", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">State</label>
                <div class="input-group mb-3">
                  <Controller
                    name="stateId"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        className={`${errors.stateId ? "is-invalid" : ""}`}
                        value={
                          userData?.stateId
                            ? userData?.stateId
                            : getValues("stateId")
                        }
                        disabled={userData?.stateId}
                        onChange={stateChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {stateList.map((item) => (
                          <Option key={item.stateId} value={item.stateId}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                </div>
                <label for="basic-url">Country</label>
                <div class="input-group mb-3">
                  <Controller
                    name="countryId"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        className={`${errors.countryId ? "is-invalid" : ""}`}
                        value={
                          userData?.countryId
                            ? userData?.countryId
                            : getValues("countryId")
                        }
                        disabled={
                          userData?.countryId && userData?.isUserVerified
                        }
                        onChange={countryChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {countries.map((item) => (
                          <Option key={item.countryId} value={item.countryId}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                </div>
                <label for="basic-url">Pincode</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    disabled={userData?.pinCode}
                    id="pinCode"
                    aria-describedby="basic-addon3"
                    {...register("pinCode", {
                      required: true,
                    })}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ width: "30px", height: "30px" }}
                  className="bi bi-bank2 mx-3"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
                </svg>
                Bank Details
              </Accordion.Header>
              <Accordion.Body className="mx-0 mx-md-5">
                <label for="basic-url">Bank Account Number</label>
                <div class="input-group mb-3">
                  <input
                    disabled={userData?.bankAccountNumber}
                    type="text"
                    class="form-control"
                    id="pinCode"
                    aria-describedby="basic-addon3"
                    {...register("bankAccountNumber", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Bank</label>
                <div class="input-group mb-3">
                  <Controller
                    name="bankId"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        className={`${errors.bankId ? "is-invalid" : ""}`}
                        disabled={userData?.bankId}
                        value={getValues("bankId")}
                        onChange={bankNameChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {bankList.map((item) => (
                          <Option key={item.bankId} value={item.bankId}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                </div>
                <label for="basic-url">Account Type</label>
                <div class="input-group mb-3">
                  <Controller
                    name="accountType"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <Select
                        className={`${errors.accountType ? "is-invalid" : ""}`}
                        disabled={userData?.accountType}
                        value={getValues("accountType")}
                        onChange={accountTypeChange}
                        size="large"
                        style={{ width: "100%" }}
                      >
                        {getBankAccountType()}
                      </Select>
                    )}
                  />
                </div>
                <label for="basic-url">UPI ID</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="UPICode"
                    disabled={userData?.UPICode}
                    aria-describedby="basic-addon3"
                    {...register("UPICode", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">IFSC Code</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    disabled={userData?.IFSCCode}
                    id="IFSCCode"
                    aria-describedby="basic-addon3"
                    {...register("IFSCCode", {
                      required: true,
                    })}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  fill="currentColor"
                  className="bi bi-person-fill mx-3"
                  style={{ width: "30px", height: "30px" }}
                  viewBox="0 0 16 16"
                >
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                </svg>
                Nominee Details
              </Accordion.Header>
              <Accordion.Body className="mx-0 mx-md-5">
                <label for="basic-url">Name</label>
                <div class="input-group mb-3">
                  <input
                    disabled={userData?.nominees[0]?.name}
                    type="text"
                    class="form-control"
                    id="pinCode"
                    aria-describedby="basic-addon3"
                    {...register("nomineeName", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Contact Number</label>
                <div class="input-group mb-3">
                  <input
                    disabled={userData?.nominees[0]?.contactNo}
                    type="text"
                    class="form-control"
                    id="pinCode"
                    aria-describedby="basic-addon3"
                    {...register("nomineeContact", {
                      required: true,
                    })}
                  />
                </div>

                <label for="basic-url">Relation</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="UPICode"
                    disabled={userData?.nominees[0]?.relationship}
                    aria-describedby="basic-addon3"
                    {...register("nomineeRelationship", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Email</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="UPICode"
                    disabled={userData?.nominees[0]?.email}
                    aria-describedby="basic-addon3"
                    {...register("nomineeEmail", {
                      required: true,
                    })}
                  />
                </div>
                <label for="basic-url">Date Of Birth</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="UPICode"
                    disabled={userData?.nominees[0]?.dob}
                    aria-describedby="basic-addon3"
                    {...register("nomineeDob", {
                      required: true,
                    })}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </section>
    </div>
  );
}
